import {Component, EventEmitter, Input, Output} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {ActivatedRoute, Router} from '@angular/router';
import {IdexService} from 'app/idex.service';
import {Path} from 'app/shared/path';
import {Mimetype} from '../../shared/mimetype';

declare let $: any;

@Component({
  selector: 'app-google-drive-folders',
  templateUrl: './google-drive-folders.component.html',
  styleUrls: ['../folders/folders.component.css'],
   animations: [
      trigger('state', [
         state('collapse', style({height: 0})),
         state('expand', style({height: '*'})),
         transition('collapse => expand', animate('400ms ease-in')),
         transition('expand => collapse', animate('400ms ease-out'))
      ])
   ]
})
export class GoogleDriveFoldersComponent {

   @Input() tin: string;
   @Input() parent = '';
   @Input() path = '';
   @Input() parentPath = '';
   @Input() move = false;
   @Input() exportPath = false;
   @Input() selectFile = false;
   @Input() selectSite = false;
   @Input() select_id: any;
   @Input() drivePath: string;
   @Input() access_token: string;
   @Input() selectedItems: any;
   @Input() typeName: any;
   @Input() sourceItem: any;
   @Input() currentParent: any;

   m = false;
   animationState = 'collapse';
   folders: any[] = [];
   loading = false;
   error: string;
   selectedItem: any;
   selected: boolean;
   givePath: string;
   isSelect: boolean;
   folderMimeType: string = 'application/vnd.google-apps.folder';
   shortcutMimeType: string = 'application/vnd.google-apps.shortcut';
   pdfMimeType: string = 'application/pdf';
   @Output() selectPath = new EventEmitter<boolean>();
   @Output() getPath = new EventEmitter<any>();
   @Output() errorHandler = new EventEmitter<any>();

   constructor(private router: Router, private service: IdexService, private activatedRoute: ActivatedRoute) {
   }

   toggle(item?: any) {
      this.loading = true;
      if (item) {
         this.sourceItem = item;
      }
      if (this.isExpanded()) {
         this.setAnimationState();
         this.loading = false;
      } else {
         if (!this.exportPath){
            this.service.getGoogleDriveList((this.drivePath == null || this.drivePath == undefined) ? "root" : this.drivePath, this.access_token, 0, null)
               .subscribe(res => {
                  const data = JSON.parse(res);
                  this.folders = data.files;
                  this.setAnimationState();
               }, error => {
                  this.error = error;
               }).add(() => {
               this.loading = false;
            });
         } else {
            this.service.getGoogleDriveList((this.drivePath == null || this.drivePath == undefined) ? "root" : this.drivePath, this.access_token, 0, null)
               .subscribe(async res => {
                  const data = JSON.parse(res);
                  this.folders = await this.filterItems(data.files, this.folderMimeType);
                  this.setAnimationState();
               }, error => {
                  this.error = error;
               }).add(() => {
               this.loading = false;
            });
         }
      }
   }

   setAnimationState(){
      setTimeout(() => {
         this.animationState = this.animationState === 'collapse' ? 'expand' : 'collapse';
      }, 100);
   }

   filterItems(arr, query) {
      return arr.filter((el) => el.mimeType.toLowerCase() === query.toLowerCase());
   }

   isExpanded(): boolean {
      return this.animationState === 'expand';
   }

   getFragment(name: string): string {
      return this.path ? this.path + '/' + name : name;
   }

   select(name: any, sub: any, isFolder: boolean) {
      if (this.isSelect) {
         if(this.exportPath){
            $('.selectedPath').removeClass('selectedPath');
            $('#export_' + name.id).addClass('selectedPath');
         } else {
            $('.selectedPath').removeClass('selectedPath');
            $('#move' + name.id).addClass('selectedPath');
         }
         if (!sub.isExpanded() && isFolder) {
            sub.toggle();
         }
         if (this.selectedItem === sub) {
            return;
         }
         if (this.selectedItem) {
            this.selectedItem.selected = false;
         }
         this.selectedItem = sub;
         sub.selected = true;
      }
   }

   onSelectPath(agreed: any) {
      if(this.exportPath){
         this.selectPath.emit(agreed);
         this.isSelect = true;
      }else{
         if (agreed.file) {
            this.selectPath.emit(agreed);
            this.isSelect = true;
         } else {
            this.isSelect = false;
         }
      }

   }

   onGetPath(name) {
      if (this.isSelect || this.exportPath) {
         this.getPath.emit(this.parentPath + name);
      }
   }

   getIconGoogleDrive(item: any): string {
      return Mimetype.getIconGoogleDrive(item);
   }

   googleDriveIsFolder(item: any): boolean {
      return Boolean(item.mimeType === this.folderMimeType)
   }

   expand(folders: any) {
      if (!folders.isExpanded()) {
         folders.toggle();
      }
   }

   selectFiles(event: any, item: any, uploadType: 'zDox' | 'google drive') {
      if (this.getValidateExtension(item.mimeType)) {
         event.preventDefault();
         item.selected = !item.selected;
         const index = this.selectedItems.indexOf(item);
         if (item.selected) {
            if (index === -1) {
               item.uploadType = uploadType;
               this.selectedItems.push(item);
            }
         } else {
            if (index !== -1) {
               this.selectedItems.splice(index, 1);
            }
         }
      }
   }

   getValidateExtension(item:any):boolean{
      if (item) {
         return Mimetype.validateExtension(item, this.typeName);
      } else {
         return true;
      }
   }

   unselect(): void {
      if(this.exportPath){
         $('.selectedPath').removeClass('selectedPath');
      }
      if (this.selectedItem) {
         this.selectedItem.selected = false;
         this.selectedItem = undefined;
      }
   }

   isSameFolder(destinationFolder: any): boolean {
      if(this.activatedRoute.snapshot.queryParams['fileId'] != null){
         return destinationFolder == this.currentParent;
      }else{
         if(this.sourceItem?.id == destinationFolder) return true;
         return false;
      }
   }
}
